import React from 'react';
import { Box, Portal } from '@stockx/ui';
import { ConfirmModal } from '@app/ui';
import { GlobalSMSModal } from '@app/sms';

import { LazyLocationSelectorDrawer } from '@app/locationSelector';
import SiteHeader from '../SiteHeader/Header';
import SkipToContent from './components/SkipToContent';
import Footer from '../SiteFooter/FooterLazy';
import Main from './components/Main';
import WhereAreYou from './components/WhereAreYou';
import LocalizationMenu from './components/LocalizationMenu/LocalizationMenuLazy';
import GlobalStyles from './components/GlobalStyles';

const AppView = ({ children }) => (
  <React.Fragment>
    <GlobalStyles />

    {/* App View */}
    <Box className="app-layout" minHeight="100vh" overflowX="clip" width="100%">
      <SkipToContent />
      <SiteHeader />
      <Main>{children}</Main>
      <Footer />
    </Box>

    {/* Various Global Modals / features / etc. */}
    <Portal>
      <LocalizationMenu />
      <WhereAreYou />
      <ConfirmModal />
      <GlobalSMSModal />
      <LazyLocationSelectorDrawer />
    </Portal>
  </React.Fragment>
);

export default AppView;
